export default __webpack_public_path__ + "static/media/logo.e4dfa161.svg";